"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const intl_1 = require("@kyruus/intl");
const styles_1 = require("./styles");
const utils_1 = require("../../lib/utils");
const messages_1 = __importDefault(require("../../lib/messages"));
const with_error_boundary_1 = require("../ErrorFallback/with-error-boundary");
const Gender = ({ provider, config, shouldSkipRender, intl }) => {
    var _a;
    const isGenderValueIgnored = (((_a = config.provider_v9) === null || _a === void 0 ? void 0 : _a.summary_data) || []).find((s) => s.field === 'gender' &&
        Array.isArray(s.ignore) &&
        s.ignore.includes(provider.gender));
    const skipRendering = !(0, utils_1.isSummaryDataConfigured)('gender', config) ||
        !provider.gender ||
        isGenderValueIgnored;
    (0, react_1.useEffect)(() => {
        if (skipRendering) {
            // callback to the parent component to skip rendering
            shouldSkipRender('gender');
        }
    }, [skipRendering]);
    // do not render if summary_data field not present
    // or data is not present
    // gender is falsy or icon is not found
    if (skipRendering) {
        return null;
    }
    return (react_1.default.createElement(styles_1.ProviderInformationCard, null,
        react_1.default.createElement(styles_1.CardContentContainer, null,
            react_1.default.createElement(styles_1.CardContentHeader, null, intl.formatMessage(messages_1.default.genderHeader)),
            react_1.default.createElement(styles_1.CardContentText, null, provider.gender))));
};
exports.default = (0, with_error_boundary_1.withErrorBoundary)((0, intl_1.injectIntl)(Gender));
//# sourceMappingURL=gender.js.map